import type { FaireProductEntity } from "../../entity_types/product";

export const p_wqvsq3qpxk: FaireProductEntity = {
  token: "p_wqvsq3qpxk",
  type: "product",
  name: "Calder Sweater Tee - Vista",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/921783bd52014e9baae24de6b1d7105acec8f1ce766ea7f97b66edbfc8cc9f6b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/454962177642e046e9f4d0b820920eef76d299f9695d964180746fd000916297.jpeg",
    "https://cdn.faire.com/fastly/f179363240f87c5e58e045fdb93746fef3f561a42d9fc4646409a5eb2a20bb79.jpeg",
    "https://cdn.faire.com/fastly/34fd202a48af471e775008cc7d83e7acd6d28c75af6ec6555b826ecef904189f.jpeg",
    "https://cdn.faire.com/fastly/02e81c518882d437c841630272899b97c5bceb23bef8e05c1316d4a4b36ce760.jpeg"
  ],
  priceDollars: 75.6,
  description: "The Calder Tee has a relaxed silhouette that holds its shape, sitting cleanly on the body with a clear, defined line. The cotton has a smooth, flat finish with minimal drape. It works equally well on its own or layered, making it a reliable piece year-round.\n\nInspired by painted tile work observed in Lima, the pattern introduces a new sense of rhythm and color while maintaining a clean, graphic foundation. The surface feels considered without overwhelming the form, allowing it to pair easily with a range of silhouettes, from tailored trousers to more voluminous skirts or dresses.\n\n• 100% cotton\n• Relaxed fit that holds its shape\n• Smooth, flat finish with minimal drape\n• Maintains a clean silhouette and resists wrinkling\n• Designed for year-round wear\n• Pairs well with trousers, denim, or layered over dresses and skirts",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:28.819Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
